var $ = jQuery;

/**
 * Opening the menu used to do one thing: add `.show`. The page behind kept
 * scrolling, there was nothing to tap to get out of it, Escape did nothing, and
 * the hamburger never told a screen reader whether the panel was open. On a
 * phone, where the panel covers the whole screen, that leaves the close button
 * as the only way back - and it scrolls away with the page underneath.
 */
function setMenu(open) {
    $('.menu-overlay').toggleClass('show', open);
    $('.menu-backdrop').toggleClass('show', open);
    $('.menu-btn').attr('aria-expanded', open ? 'true' : 'false');
    // `.freeze` is the theme's existing scroll lock. `.bv-menu-open` is kept
    // separate from the sheets' own `.bv-sheet-open` so closing the menu on a
    // page that has a sheet up does not clear the sheet's flag too.
    $('html, body').toggleClass('freeze bv-menu-open', open);

    if (open) {
        $('.menu-overlay').find('a, button').first().trigger('focus');
    } else {
        $('.menu-btn').trigger('focus');
    }
}

$(document).on('ready', function () {
    $(document).on('click', '.menu-btn', function () {
        setMenu(true);
    });

    $(document).on('click', '.close-menu, .menu-backdrop', function () {
        setMenu(false);
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $('.menu-overlay').hasClass('show')) {
            setMenu(false);
        }
    });

    $(document).on('click', '.open-mobile-filter', function () {
        $('body').addClass('overflow-hidden');
    });

    $(document).on('click', '.close-mobile-filter', function () {
        $('body').removeClass('overflow-hidden');
    });
});
